module.exports = __webpack_public_path__ + "img/login_biaoti3.dd8a6c52.png";